import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PrivateRoute from "../components/layout/PrivateRoute";

import Dashboard from "../pages/Dashboard/Dashboard";
import Jobs from "../pages/Jobs/Jobs";
import ExecuteJob from "../pages/Jobs/ExecuteJob";
import CreateJob from "../pages/Jobs/CreateJob";

import Processes from "../pages/Processes/Processes";
import CreateProcess from "../pages/Processes/CreateProcess";
import Activities from "../pages/Processes/Activities/Activities";
import CreateActivity from "../pages/Processes/Activities/CreateActivity";

import Login from "../pages/Login/Login";
import Home from "../pages/Home";
import HomeOrDashboard from "./HomeOrDashboard";
import ControlOperativo from "../pages/SEO/ControlOperativo";
import SoftwareManufactura from "../pages/SEO/SoftwareManufactura";

export default function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>

        {/* ✅ HOME AHORA ES LA RAÍZ */}
        <Route path="/" element={<HomeOrDashboard />} />
        <Route path="/control-operativo-en-campo" element={<ControlOperativo />}/>
        <Route path="/software-para-manufactura" element={<SoftwareManufactura />}/>

        {/* Públicas */}
        <Route path="/login" element={<Login />} />

        {/* 🔒 Rutas protegidas */}
        <Route element={<PrivateRoute />}>

          {/* Dashboard ahora tiene su propia ruta */}
          <Route path="/dashboard" element={<Dashboard />} />

          {/* Jobs */}
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/jobs/create" element={<CreateJob />} />
          <Route path="/jobs/:id/execute" element={<ExecuteJob />} />

          {/* Processes */}
          <Route path="/processes" element={<Processes />} />
          <Route path="/processes/create" element={<CreateProcess />} />
          <Route path="/processes/edit/:processId" element={<CreateProcess />} />

          {/* Activities */}
          <Route
            path="/processes/:processId/activities"
            element={<Activities />}
          />
          <Route
            path="/processes/:processId/activities/create"
            element={<CreateActivity />}
          />
          <Route
            path="/processes/:processId/activities/edit/:activityId"
            element={<CreateActivity />}
          />

        </Route>

        {/* Fallback */}
        <Route path="*" element={<Home />} />

      </Routes>
    </BrowserRouter>
  );
}
